import {Actions, createEffect, ofType} from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import {concatMap, filter, map, withLatestFrom} from 'rxjs/operators';
import {AppState} from './index';
import { select, Store} from '@ngrx/store';
import {isActiveCourseLessonsLoaded, selectUser} from './selectors';
import {UserLessonStatusDbService} from '../services/user-lesson-status.db.service';

import {isAnonymousUser} from '../models/user.model';
import {CourseActions, UserLessonStatusActions} from './action-types';
import {userLessonsStatusLoaded} from './user-lesson-status.actions';
import { UserActivityLogService } from "../services/user-activity-log.service";


@Injectable({
  providedIn: 'root'
})
export class UserLessonStatusEffects {
  private actions$ = inject(Actions);
  private store = inject<Store<AppState>>(Store);
  private userLessonsDb = inject(UserLessonStatusDbService);
  private userActivitiyLogService = inject(UserActivityLogService);


  loadLessonsWatchedByCourseIfNeeded$ = createEffect(() => this.actions$
    .pipe(
      ofType(CourseActions.loadCourseDetail),
      withLatestFrom(this.store.pipe(select(isActiveCourseLessonsLoaded))),
      filter(([action, loaded]) => !loaded),
      map(([action, loaded]) => action),
      withLatestFrom(this.store.pipe(select(selectUser))),
      filter(([action, user]) => !isAnonymousUser(user)),
      concatMap(([{courseId}, user]) =>
        this.userLessonsDb.loadLessonsWatchedByCourse(user.id, courseId)
          .pipe(
            map(userLessonsStatusList => [courseId, userLessonsStatusList])
          )
      ),
      map( ([courseId, userLessonsStatusList]:any) => userLessonsStatusLoaded({courseId,userLessonsStatusList}))
    ));

  saveLessonStatus = createEffect(() =>this.actions$
    .pipe(
      ofType(UserLessonStatusActions.updateLessonWatchStatus),
      withLatestFrom(this.store.pipe(select(selectUser))),
      filter(([action, user]) => !isAnonymousUser(user)),
      concatMap(([action, user]) => this.userLessonsDb.saveLessonStatus(user.id, action.userLessonStatus))
    ),
    {dispatch: false});

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

  }

}
